export enum VenueRuleTypeDTO {
    ShortSelling = 'SHORT_SELLING',
}

export type VenueRuleValuesDTO = {
    maximumCapacity?: number | null,
    minimumPartySize?: number | null,
    [key: string]: number | null | undefined,
}

export class VenueRuleDTO {
    constructor(
        public id: string,
        public type: VenueRuleTypeDTO,
        public daysOfWeek: number[],
        public values: VenueRuleValuesDTO
    ) { }
}
